import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

const CustomerContext = createContext(null);

export const CustomerProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const t = localStorage.getItem("aurelia_customer_token");
    if (!t) {
      setReady(true);
      return;
    }
    api
      .get("/auth/me", { headers: { Authorization: `Bearer ${t}` } })
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("aurelia_customer_token"))
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("aurelia_customer_token", data.token);
    setUser(data.user);
    return data;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    localStorage.setItem("aurelia_customer_token", data.token);
    setUser(data.user);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("aurelia_customer_token");
    setUser(null);
  };

  const value = useMemo(() => ({ user, ready, login, register, logout }), [user, ready]);
  return <CustomerContext.Provider value={value}>{children}</CustomerContext.Provider>;
};

export const useCustomer = () => useContext(CustomerContext);
